import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/app/_app/org/$orgId/customers")({
	component: () => <Outlet />,
});
